import { useEffect, useState } from 'react';
import { getExchangeRate } from 'services/common';

interface Fiat {
  name: string;
  rate: string;
  full_name: string;
  precision: string;
  symbol: string;
}

interface Rates {
  usdt_usd: string;
  fiat: Fiat[];
}

const useRates = () => {
  const [rates, setRates] = useState<Rates | null>(null);

  const getRates = async () => {
    try {
      const res = await getExchangeRate<{
        data: Rates;
      }>();
      if (res.code === 200) {
        setRates(res.data);
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    getRates();
  }, []);

  return {
    rates,
  };
};

export default useRates;
